<template>
  <section
    id="schedule"
    class="schedule"
    :style="{
      backgroundImage: `url(${agendaConfig.bgImage})`,
      '--agenda-fontSize': agendaConfig.fontSize,
      '--agenda-textColor': agendaConfig.textColor,
      '--agenda-activeTextColor': agendaConfig.activeTextColor,
      '--agenda-activeBgColor': agendaConfig.activeBgColor,
      '--agenda-bgColor': agendaConfig.bgColor,
      '--agenda-borderColor': agendaConfig.borderColor,
      '--agenda-activeBorderColor': agendaConfig.activeBorderColor,
      '--agenda-borderRadius': agendaConfig.borderRadius,
      '--agenda-margin': agendaConfig.margin,
      '--agenda-padding': agendaConfig.padding,
      '--agenda-dayMaxWidth': agendaConfig.dayMaxWidth,
    }">
    <Header />
    <div class="schedule-container">
      <button v-if="isUserAdmin" class="agendas-manager-toggle" @click="toggleScheduleManager" :disabled="isLoading">
        {{ isLoading ? 'Salvando...' : 'Editar' }}
      </button>
      <div class="days-and-tabs-container">
        <div class="days">
          <div v-for="(day, k) in scheduleSortedByDate" :key="day.date_start + k" class="day" :class="{ activeDay: isActive(day.date_start) }" @click.prevent="setActive(day.date_start)" v-html="day.agenda"></div>
        </div>
        <div class="tabs">
          <div v-for="(day, k) in daysComputed" :key="day.date_start + k" class="tab">
            <img :src="day.image" v-if="isFoyer2DRoute(day.image)" />
            <Foyer2D :externalStream="day.image" v-else />
          </div>
        </div>
      </div>
      <ScheduleManager v-if="showScheduleManager" :agendas="schedule" @save="saveAgenda" @close="showScheduleManager = false" @delete-agenda="deleteAgenda($event)" />

      <div class="loading-overlay" v-if="isLoading">
        <div class="loading-spinner"></div>
        <p>Processando...</p>
      </div>
    </div>
    <Footer />
  </section>
</template>

<script>
import Header from '@/components/general/Header.vue';
import Footer from '@/components/general/Footer.vue';
import api from '@/services/api.js';
import * as dayjs from 'dayjs';
import Foyer2D from '@/views/Foyer2D';
import ScheduleManager from '@/components/general/ScheduleManager.vue';

export default {
  name: 'Schedule',
  components: { Header, Footer, Foyer2D, ScheduleManager },
  data() {
    return {
      schedule: [],
      activeItem: '',
      dayjs: null,
      bgSchedule: null,
      accessConfig: {},
      agendaConfig: {},
      isUserAdmin: false,
      showScheduleManager: false,
      isLoading: false,
    };
  },
  computed: {
    scheduleSortedByDate: function () {
      return this.schedule.sort((a, b) => new Date(a.date_start) - new Date(b.date_start));
    },
    daysComputed: function () {
      return this.schedule.filter((agenda) => {
        return agenda.date_start === this.activeItem;
      });
    },
  },
  methods: {
    isActive(menuItem) {
      return this.activeItem === menuItem;
    },
    setActive(menuItem) {
      this.activeItem = menuItem;
      api.post(`sessionAction/`, {
        action: 'Schedule Action - setActive',
        properties: JSON.stringify({
          route: this.$route.name,
          params: this.$route.params,
          activeItem: this.daysComputed,
          activeDate: this.activeItem,
        }),
        userid: this.$store.state.user.id,
        sessionid: this.$store.state.user.token,
        event_id: this.$store.state.eventId,
      });
    },
    setCurrentDateTab() {
      this.activeItem = this.schedule[0]?.date_start;
      let currentDateFormatted = dayjs(Date.now()).format('DD/MM/YYY');
      for (let i = 0; i < Object.keys(this.schedule).length; i++) {
        let dateID = dayjs(this.schedule[i].date_start).format('DD/MM/YYY');
        if (dateID == currentDateFormatted) {
          this.activeItem = this.schedule[i].date_start;
        }
        if (this.$route.params.date_start) this.activeItem = this.$route.params.date_start;
      }
    },
    isFoyer2DRoute(input) {
      if (!input.includes('.')) return false;
      else return true;
    },
    async saveAgenda(agenda) {
      this.isLoading = true;
      try {
        let payload = {
          agenda: agenda.agenda,
          date_start: agenda.date_start,
          image: agenda.image,
        };
        if (agenda.agenda_id) {
          await api.put(`event/${this.$store.state.eventId}/agenda/${agenda.agenda_id}`, payload);
        } else {
          await api.post(`event/${this.$store.state.eventId}/agenda`, payload);
        }
        await this.reloadAgenda();
      } catch (err) {
        console.error('Erro ao salvar agenda:', err);
      }
      this.isLoading = false;
    },
    async deleteAgenda(id) {
      this.$modal.show('dialog', {
        title: 'ATENÇÃO! Ação não recuperável',
        text: 'Deseja excluir agenda?',
        buttons: [
          {
            title: 'Sim',
            handler: async () => {
              try {
                this.isLoading = true;
                await api.delete(`event/${this.$store.state.eventId}/agenda/${id}`);
                await this.reloadAgenda();
                this.showScheduleManager = false;
                this.isLoading = false;
                this.$modal.hide('dialog');
              } catch (error) {
                console.error('Erro ao excluir agenda:', error);
                this.isLoading = false;
                this.$modal.hide('dialog');
              }
            },
          },
          {
            title: 'Não',
            handler: () => {
              this.$modal.hide('dialog');
            },
          },
        ],
      });
    },
    async reloadAgenda() {
      let languageFilter = '';
      if (this.$store.state.template.multilanguagesConfig) {
        languageFilter = `?language_code=${this.$store.state.user.language}`;
      }
      const response = await api.get(`event/${this.$store.state.eventId}/agenda${languageFilter}`);
      this.schedule = response.data;
      this.setCurrentDateTab();
    },
    toggleScheduleManager() {
      this.showScheduleManager = !this.showScheduleManager;
      // Force close any open editor in ScheduleManager by emitting cancel if closing
      if (!this.showScheduleManager) this.$emit('cancel');
    },
  },
  beforeMount() {
    this.agendaConfig = this.$store.state.template.agendaConfig;
    this.accessConfig = this.$store.state.template.accessConfig;

    let userLanguage = this.$store.state.user.language ? this.$store.state.user.language.toLowerCase() : 'pt';
    if (this.$store.state.template.multilanguagesConfig) {
      this.accessConfig = this.$store.state.template.accessConfig[`accessConfig_${userLanguage}`];
    }
    this.bgSchedule = this.accessConfig.bgSchedule ? this.accessConfig.bgSchedule : null;
    this.isUserAdmin = this.$store.state.user.role === '1819bd5e-7b46-11ea-bc55-0242ac130003' || this.$store.state.user.role === '1819bea8-7b46-11ea-bc55-0242ac130003';
  },
  mounted() {
    this.dayjs = dayjs;
    let languageFilter = '';
    if (this.$store.state.template.multilanguagesConfig) {
      languageFilter = `?language_code=${this.$store.state.user.language}`;
    }
    api
      .get(`event/${this.$store.state.eventId}/agenda${languageFilter}`)
      .then((response) => {
        this.schedule = response.data;
        this.setCurrentDateTab();
      })
      .catch((err) => {
        console.error(err);
      });
    this.setCurrentDateTab();
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Major+Mono+Display');

.schedule {
  position: relative;
  background-color: var(--main-color);
  width: 100vw;
  // min-height: 100dvh;
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
  background-repeat: repeat-y;

  @include media('<=1042px') {
    // background-size: contain;
  }
}

.schedule-container {
  position: relative;
  width: 100vw;
  min-height: 97vh;
  padding: 2%;
  padding-top: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @include media('<=phone') {
    padding-top: 70px;
  }
  @media (max-height: 460px) {
    padding-top: 70px;
  }
}

.days {
  background-color: transparent;
  display: flex;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 1080px;
  // padding: 0 2%;
  // margin-bottom: 10px;
  list-style: none;
  user-select: none;
}
.day {
  background-color: var(--agenda-bgColor);
  color: var(--agenda-textColor);
  border: 1px solid var(--agenda-borderColor);
  border-radius: var(--agenda-borderRadius);
  margin: var(--agenda-margin);
  padding: var(--agenda-padding);
  max-width: var(--agenda-dayMaxWidth);
  // min-width: 190px;
  height: auto;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: var(--agenda-fontSize);
  font-weight: normal;
}

.activeDay {
  background-color: var(--agenda-activeBgColor);
  color: var(--agenda-activeTextColor);
}
.tabs {
  display: flex;
  justify-content: center;
  color: transparent;
  max-width: 1080px;
  background-color: transparent;
}
.tab {
  margin: 0 4px;
  min-height: 75vh;
  img {
    max-width: 100%;
  }
}
.agendas-manager-toggle {
  position: absolute;
  top: 68px;
  right: 10px;
  padding: 0.3rem 0.7rem;
  z-index: 10;

  font-size: 0.6rem;
  opacity: 0.5;
  color: white;
  background-color: #494949;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  @include media('<=phone') {
    position: fixed;
    top: 42px;
    right: 4px;
    margin: 0;
    padding: 0.5rem;
  }
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #cccccc6b;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;

  .loading-spinner {
    border: 4px solid #0000001a;
    border-top: 4px solid var(--main-color);
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
  }

  p {
    margin-top: 10px;
    font-size: 16px;
    color: #00000080;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
